var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{attrs:{"label":_vm.$t('keyword')}},[_c('el-input',{attrs:{"placeholder":_vm.$t('enter_value')},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }